module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XjUxSA/media/FC-9781035849567.jpg?1718046516817",
      "alt": "This image is the cover for the book The Secrets Within Him"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Secrets Within Him\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Amelia awakens naked and alone in the woods, her only inheritance a harrowing mystery. She has lived a lonely life until Kai – a striking yet secretive werewolf dedicated to protecting her – introduces Amelia to a wondrous new world and an astounding bequest more powerful than she could have imagined. Amelia dreams of being loved, but is she willing to sacrifice parts of herself for it? And will her growing feelings for her rugged guardian, Kai, change everything? When darkness descends, Amelia and Kai need to band together. But Amelia faces an agonizing choice: risk her life for one who betrayed her trust? With each revealed secret, there is no going back. Can this once isolated girl summon the courage to make the ultimate decision about her future and heart?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A.F. Mitchell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A.F. Mitchell has spent many years immersing herself in the fantasy world; she has a big imagination and loves creating characters and how, through hard work and dedication, everything evolves. She wanted to prove to herself and others that even though she didn’t feel educated enough, she could still achieve her dream of becoming an author. She wanted to write a novel that was easy to read and that her readers would fall in love with the narrative and characters, more so than her grammar and punctuation. She lives in Radstock, Somerset, withher husband and their daughter.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0